import { fetchAuthSession } from "aws-amplify/auth";

export async function getAccessToken(): Promise<string | null> {
  try {
    const session = await fetchAuthSession();

    const tokenObj = session.tokens?.idToken;
    if (!tokenObj) return null;

    const jwt = (tokenObj as any)?.getJwtToken?.();
    if (typeof jwt === "string" && jwt.length > 0) return jwt;

    const str = tokenObj?.toString?.();
    return typeof str === "string" && str.length > 0 ? str : null;
  } catch (error) {
    console.error("Error fetching token:", error);
    return null;
  }
}
